import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
    selector: 'app-lead-comments-widget',
    templateUrl: './lead-comments-widget.component.html',
    styleUrls: ['./lead-comments-widget.component.scss'],
    standalone: false
})
export class LeadCommentsWidgetComponent extends ListRendererWidgetBase {}
